/* Pick random */
if(typeof drupalSettings.hero_banner_images !== 'undefined'){
    let backgroundImage = pickRandomImage(drupalSettings.hero_banner_images);
    if (backgroundImage) {
        $(once('bannerSetBackground', '.banner-img')).attr('style', 'background-image: url(' + backgroundImage.url + ');').fadeIn('slow');
    }
}

function pickRandomImage(hero_banner_images){
    if($(window).width() < 720){
        hero_banner_images = removeNonMobileImages(hero_banner_images);
    }
    if(hero_banner_images.length < 1) {
        return false;
    }
    let randomPos = Math.floor(Math.random() * hero_banner_images.length);
    return hero_banner_images[randomPos];
}

function removeNonMobileImages(images) {
    let immages_array = [];
    for (let x = 0; x < images.length; x++) {

        let image = images[x];

        if(image.exclude_from_mobile && image.exclude_from_mobile == 1){
            continue;
        }

        immages_array.push(image);

    }
    return immages_array;
}

